import React from "react";
import { useTranslation } from "react-i18next";
import { RenderCommaMoney } from "utils/functions/formatMoney";

// สรุปที่นั่ง + ราคา ที่ใช้ซ้ำในหน้าชำระเงิน (S4) และหน้าตรวจสอบ (S5)
// showTransferLabel: หน้าชำระเงินมีหัว "ยอดการโอนเงิน" และยอดรวมตัวใหญ่
const SeatPriceSummary = ({ draft, showTransferLabel }) => {
  const { t } = useTranslation(["seat"]);
  return (
    <div className="price_summary">
      {showTransferLabel && <div className="ps_label">{t("Transfer total", { ns: "seat" })}</div>}
      <div className="ps_total">
        {t("Seat booking {{count}} x {{price}} =", {
          ns: "seat",
          count: draft.seats.length,
          price: RenderCommaMoney(draft.price_per_seat),
        })}{" "}
        <span className={showTransferLabel ? "ps_total_amount" : ""}>
          {RenderCommaMoney(draft.amount)} THB
        </span>
      </div>
      {draft.seats.map((s, i) => (
        <div className="ps_seat" key={s.seat_id}>
          <div className="ps_seat_name">
            Seat {i + 1} : {s.seat_id}
            {s.viewer_name ? ` · ${s.viewer_name}` : ""}
          </div>
          <div className="ps_seat_price">{RenderCommaMoney(draft.price_per_seat)} THB/Seat.</div>
        </div>
      ))}
    </div>
  );
};

export default SeatPriceSummary;
